/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */
import { apiPatch } from "../Api/apiCall";
import { getProductData } from "../Product/ProductService/productService";
import { getUpdateData } from "./persisterService";
import { UseForm } from "../../types/UseForm";
import { PendingCase } from "../../types/Products/PendingCase";
import { persistAbstractCaseSubEntities } from "./AbstractCasePersister";

export const persistPendingCase = async (updateData: UseForm["values"], origPendingCase: PendingCase) => {
  await persistAbstractCaseSubEntities(updateData, origPendingCase);

  const apiUri = getProductData(origPendingCase.productClassName, "apiUri");
  const contractCaseUpdateData = getUpdateData(updateData, origPendingCase);

  await apiPatch(apiUri, origPendingCase.id, contractCaseUpdateData);
};
